function pulseClass(element, className, duration = 180) {
  if (!element) {
    return
  }
  element.classList.remove(className)
  void element.offsetWidth
  element.classList.add(className)
  setTimeout(() => {
    element.classList.remove(className)
  }, duration)
}

function applyScoreEffects({ sound, scoreBoard, gameContainer }) {
  if (sound) {
    sound.play('default')
  }
  pulseClass(scoreBoard, 'glowText', 2000)
  pulseClass(gameContainer, 'score-flash', 220)
}

function applyPaddleHitEffects({ gameContainer, side, speed = 0 }) {
  const isLeft = side === 'left'

  if (speed > 1300) {
    pulseClass(gameContainer, isLeft ? 'hit-flash-intense-left' : 'hit-flash-intense-right', 120)
    return
  }

  if (speed > 700) {
    pulseClass(gameContainer, isLeft ? 'hit-flash-medium-left' : 'hit-flash-medium-right', 120)
    return
  }

  pulseClass(gameContainer, isLeft ? 'hit-flash-subtle-left' : 'hit-flash-subtle-right', 100)
}

function applyRallyHeatEffects({ scoreBoard, speed = 0 }) {
  if (speed > 1300) {
    pulseClass(scoreBoard, 'rally-heat-high', 220)
    return
  }

  if (speed > 700) {
    pulseClass(scoreBoard, 'rally-heat-medium', 200)
    return
  }

  pulseClass(scoreBoard, 'rally-heat-subtle', 180)
}

export {
  pulseClass,
  applyScoreEffects,
  applyPaddleHitEffects,
  applyRallyHeatEffects,
}
